import { render, staticRenderFns } from "./ProductBactivities.vue?vue&type=template&id=86dc5808&scoped=true"
import script from "./ProductBactivities.vue?vue&type=script&lang=js"
export * from "./ProductBactivities.vue?vue&type=script&lang=js"
import style0 from "./ProductBactivities.vue?vue&type=style&index=0&id=86dc5808&prod&scoped=true&lang=css"
import style1 from "./ProductBactivities.vue?vue&type=style&index=1&id=86dc5808&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86dc5808",
  null
  
)

export default component.exports